import { Collapse, IconButton } from "@mui/material";
import { useSession } from "@dvrt/web-phone-client";
import { useDebugSettings } from "conference/tools";
import DebugInfoPanel from "conference/components/meeting-page/DebugInfoPanel";
import { useBoolState } from "@dvrt/react-tools";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MenuButton from "./MenuButton";
import { PanelWrapper, Controls, VideoStyled } from "./tools";

const SelfVideoPanel = () => {
    const context = useSession();
    const track = context.localVideoTrack;
    const debugSettings = useDebugSettings();
    const [show, _1, _2, toggleShow] = useBoolState(true);

    if (!track) return null;

    return (
        <PanelWrapper>
            <Collapse in={show}>
                <VideoStyled track={track} />
            </Collapse>
            {debugSettings.enabled && debugSettings.showVideoInfo && show && (
                <DebugInfoPanel track={track} showEffect />
            )}
            <Controls style={{ left: show ? 5 : -45 }}>
                <IconButton size="small" onClick={toggleShow}>
                    <FontAwesomeIcon icon={show ? "chevron-circle-down" : "chevron-circle-up"} />
                </IconButton>
            </Controls>
            <MenuButton />
        </PanelWrapper>
    );
};

export default SelfVideoPanel;
